



















import Vue from "vue";
import { VUEX_USER_NAMESPACE, VUEX_USER_ACTION_NAMES } from "@tt-app/constants";

const { UPDATE_USER_PROFILE } = VUEX_USER_ACTION_NAMES;

interface Methods {
  updateUserProfile: () => void;
}

interface Props {
  opened: boolean;
}

export default Vue.extend<{}, Methods, {}, Props>({
  name: "SttConnectionMethodModal",
  props: {
    opened: { type: Boolean, default: false }
  },
  methods: {
    async updateUserProfile() {
      const settings = {
        useOnlyHttp: true
      };

      await this.$store.dispatch(`${VUEX_USER_NAMESPACE}/${UPDATE_USER_PROFILE}`, settings);

      location.reload();
    }
  }
});
